import type { LabelComponentType } from "../../../common-deprecated/components/label/Label";
import { getLabelComponent } from "../../../common-deprecated/components/label/Label";
import type { UseLabelType, UseOptionalLabelType } from "../../../common-deprecated/hooks/useLabel";
import { getUseLabel, getUseOptionalLabel } from "../../../common-deprecated/hooks/useLabel";
import type { CompareV2StateType } from "../redux/store";
import { T1Labels } from "../../../common-deprecated/utils/t1labels";

// ----------------------------------------------------------------------
// Accessibility labels
// ----------------------------------------------------------------------
export const accessibilityLabels = {
    ariaChangeModelGrade: "Change model and/or grade",
    ariaRemoveFromCompare: "Remove from compare",
    ariaMoreInfo: "More info",
    ariaColors: "Colors",
    ariaCompare: "Compare",
};

/**
 * New car compare
 */
export const compareV2Labels = {
    ...T1Labels,
    ...accessibilityLabels,
    // header
    compareHeaderTitle: "Compare",
    compareHeaderHide: "Hide",
    compareHeaderClearAll: "Clear all",
    compareHeaderChooseUpToXCars: "Choose up to {maxNumberOfCars} cars",
    // Promotions
    compareEvGrant: "Ev Grant",
    // modal
    compareModalDeleteCar: "Are you sure you want to remove the {carToDelete} from the comparison?",
    compareModalRemoveButton: "Remove",
    compareModalCancelButton: "Cancel",
    compareModalReplaceCar:
        "You can only compare {maxNumberToCompare} cars. Which car do you want to replace by the {newCar} ?",
    // highlight
    compareBodyTopEngine: "Engine",
    compareBodyTopSelectCar: "Select Car",
    compareBodyTopFrom: "",
    compareBodyOwnerReviews: "Owner reviews",
    // cta
    compareBodyCtaExploreGrade: "Explore grade",
    compareBodyCtaPersonalise: "Personalise",
    compareBodyRemoveCar: "Remove selection",
    compareBodySaveAsPdf: "Save comparison as PDF",
    compareBodyLoading: "loading",
    // specs
    compareBodyCarSpecsTitle: "Car Specifications",
    compareBodyCarSpecsInfo: "Your car selection affects the specifications below",
    compareBodyAdditionalSpecs: "Additional specs",
    compareBodySpaceAndRoomSpecs: "Space & Room",
    compareBodyEquipment: "Equipment",
    compareBodyEngineSpecsTitle: "Engine Specifications",
    compareBodyEngineSpecsInfo: "Your engine selection affects the specifications below",
    // legend
    compareBodyLegendStandard: "Standard",
    compareBodyLegendOptional: "Optional",
    compareBodyLegendNotApplicable: "Not applicable",
    compareBodyLegendException: "Exception",
    compareBodyLegendPromotion: "Promotion",
    compareBodyLegendOptionalPack: "Available in optional pack",
    // title
    compareBodyExpandAll: "Expand all selections",
    compareBodyCollapseAll: "Collapse all selections",
    compareBodyShowAll: "Show all",
    compareBodyShowDifferences: "Show differences only",
    // select car popup
    compareSelectGradeTitle: "Choose model",
    compareSelectGradeConfirm: "Make selection",
    compareSelectGradeCancel: "Cancel",
    compareSelectEngineConfirm: "Make selection",
    compareSelectEngineCancel: "Cancel",
    compareSelectStep: "Step {step} of {total}",
    compareSelectEngine: "Choose Engine",
    compareSelectGrade: "Choose Grade",
    compareSelectGradeNextGen: "", // "The new {model}", optional so this can't cause issues in case the old model get's deactivated later on
    compareSelectBack: "Back",
    // eta
    loadingEta: "Loading ETA",
    deliveryWeeks: "Delivery from {weeks} weeks",
    deliverySingleWeek: "Delivery this week",
    // other
    compareSectionPacks: "Packs",
};

export type CompareV2LabelType = keyof typeof compareV2Labels;

type CompareV2LabelParamType = Partial<
    Record<
        | "value"
        | "cash"
        | "maxNumberOfCars"
        | "maxNumberToCompare"
        | "carToDelete"
        | "newCar"
        | "step"
        | "total"
        | "model"
        | "weeks",
        string | number
    >
>;

export const useCompareV2Label = getUseLabel(
    (state: CompareV2StateType) => state.compareV2Settings.labels,
    (state: CompareV2StateType) => !!state.commonSettings.query.showDictionaryKeys,
) as UseLabelType<CompareV2LabelType, CompareV2LabelParamType>;
export const useCompareV2OptionalLabel = getUseOptionalLabel(
    (state: CompareV2StateType) => state.compareV2Settings.labels,
    (state: CompareV2StateType) => !!state.commonSettings.query.showDictionaryKeys,
) as UseOptionalLabelType<CompareV2LabelType, CompareV2LabelParamType>;
export const CompareV2Label = getLabelComponent(useCompareV2Label) as LabelComponentType<
    CompareV2LabelType,
    CompareV2LabelParamType
>;
